import React from 'react';
import ProfileLayout from 'components/ProfileLayout';
import MyPhotos from 'components/user/MyPhotos';

const ProfilePhotosPage = () => {
    return (
        <ProfileLayout>
            <MyPhotos />
        </ProfileLayout>
    );
};

export default ProfilePhotosPage;
